module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_cyclebar-8f36d1c3089f20b680e2565cda0f1a1d.svg";